module.exports = __webpack_public_path__ + "static/img/lensflare0_alpha.614e5f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/threex/spaceships/lensflare0_alpha.png
// module id = 131
// module chunks = 1